import Resource from 'api/resource';
import http from 'utils/http';
class FAQResource extends Resource {
  constructor() {
    super('data-report/data-request/');
  }

  itemList(query?: any) {
    return http({
      url: `/${this.uri}`,
      method: 'get',
      params: query,
    });
  }
}

export { FAQResource as default };
